"use client";

import React from "react";

import { useMatchBreakpoints } from "../../hooks";
import { ReturnedProductListItemSkeleton } from "../ReturnedProductListItem";

export const ReturnDetailsSkeleton: React.FC = () => {
  const { isXs, isSm, isMd } = useMatchBreakpoints();
  const isMobile = isXs || isSm || isMd;

  return (
    <div className="animate-pulse">
      {/* Header */}
      <div className="mb-6">
        <div className="h-7 bg-gray-200 rounded w-64"></div>
      </div>

      {/* Download form section */}
      <div className="mb-6 border border-gray-200 p-6 flex justify-center gap-2 bg-gray-50">
        <div className="flex gap-2 items-center">
          <div className="w-6 h-6 bg-gray-200 rounded"></div>
          <div className="h-5 bg-gray-200 rounded w-40"></div>
        </div>
      </div>

      {/* Order information section */}
      <div className="mb-6">
        <div className="h-6 bg-gray-200 rounded w-48"></div>
      </div>

      <div className="bg-gray-50 shadow-sm p-6 mb-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          <div>
            <div className="h-4 bg-gray-200 rounded w-24 mb-1"></div>
            <div className="h-5 bg-gray-200 rounded w-16"></div>
          </div>
          <div>
            <div className="h-4 bg-gray-200 rounded w-16 mb-1"></div>
            <div className="h-5 bg-gray-200 rounded w-20"></div>
          </div>
          <div>
            <div className="h-4 bg-gray-200 rounded w-12 mb-1"></div>
            <div className="h-5 bg-gray-200 rounded w-24"></div>
          </div>
          <div>
            <div className="h-4 bg-gray-200 rounded w-20 mb-1"></div>
            <div className="h-5 bg-gray-200 rounded w-32"></div>
          </div>
        </div>
      </div>

      {/* Delivery and payment forms */}
      <div className="grid md:grid-cols-2 gap-6">
        <div className="bg-gray-50 shadow-sm p-6 mb-0 md:mb-6 flex flex-col gap-2">
          <div className="h-5 bg-gray-200 rounded w-28"></div>
          <div className="h-4 bg-gray-200 rounded w-36"></div>
        </div>

        <div className="bg-gray-50 shadow-sm p-6 mb-6 flex flex-col gap-2">
          <div className="h-5 bg-gray-200 rounded w-28"></div>
          <div className="h-4 bg-gray-200 rounded w-32"></div>
        </div>
      </div>

      {/* Return information section */}
      <div className="mb-6">
        <div className="h-6 bg-gray-200 rounded w-44"></div>
      </div>

      <div className="bg-gray-50 shadow-sm p-6 mb-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          <div>
            <div className="h-4 bg-gray-200 rounded w-24 mb-1"></div>
            <div className="h-5 bg-gray-200 rounded w-16"></div>
          </div>
          <div>
            <div className="h-4 bg-gray-200 rounded w-16 mb-1"></div>
            <div className="h-5 bg-gray-200 rounded w-20"></div>
          </div>
          <div>
            <div className="h-4 bg-gray-200 rounded w-24 mb-1"></div>
            <div className="h-5 bg-gray-200 rounded w-28"></div>
          </div>
        </div>
      </div>

      {/* Return data */}
      <div className="grid md:grid-cols-2 gap-6">
        <div className="bg-gray-50 shadow-sm p-6 mb-6 flex flex-col gap-2">
          <div className="h-5 bg-gray-200 rounded w-24"></div>

          <div className="flex flex-col gap-1">
            <div className="h-4 bg-gray-200 rounded w-40"></div>
            <div className="h-4 bg-gray-200 rounded w-56"></div>
            <div className="h-4 bg-gray-200 rounded w-48"></div>
            <div className="h-4 bg-gray-200 rounded w-32"></div>

            <div className="h-4 bg-gray-200 rounded w-28 mt-2"></div>
            <div className="h-4 bg-gray-200 rounded w-72"></div>
          </div>
        </div>
      </div>

      {/* Returned products list */}
      <div className="bg-gray-50 shadow-sm p-6 mb-6">
        <div className="h-5 bg-gray-200 rounded w-48 mb-4"></div>

        <div className="space-y-4 mb-12 md:mb-4 -mx-3 md:mx-0">
          {isMobile ? (
            // Mobile slider skeleton
            <div className="space-y-4">
              <ReturnedProductListItemSkeleton />
              {/* Dots indicator */}
              <div className="flex justify-center gap-2 mt-8">
                <div className="w-3 h-3 bg-gray-200 rounded-full"></div>
                <div className="w-3 h-3 bg-gray-200 rounded-full"></div>
                <div className="w-3 h-3 bg-gray-200 rounded-full"></div>
              </div>
            </div>
          ) : (
            // Desktop list skeleton
            <div className="space-y-3">
              <ReturnedProductListItemSkeleton />
              <ReturnedProductListItemSkeleton />
              <ReturnedProductListItemSkeleton />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
